import Cookies from "universal-cookie";

export default () => {

  /**
   * Runs a function one time cookied
   * @param {*} func The function
   * @param {*} key Key to check
   */
  const runOnce = (func, key) => {
    const cookies = new Cookies();

    if (!cookies.get(key)) {
      func();

      cookies.set(key, "true", {
        maxAge: 60 * 60 * 24 * 365 * 4,
        path: "/",
      });
    }
  };

  return runOnce;
};
